// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3RgxS","log":"ModalInventoryLogs_log__3FCw_","date":"ModalInventoryLogs_date__ENSvu","userName":"ModalInventoryLogs_userName__3w_F4"};